/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { httpGet } from "../services/Http.service"
import { Project } from "../types/project.type"
import { AxiosResponse } from "axios"
import { apiUrl } from "../configs/config.constants"

export function useGetProject() {
  const [project, setProject] = useState<Project>()
  const [isLoading, setIsLoading] = useState(true)
  const host = window.location.host
  const domain = host.split('.')[0]

  useEffect(() => {
    getProject()
  }, [domain])

  function getProject() {
    setIsLoading(true)
    httpGet(apiUrl.project.get(domain))
      .then((response: AxiosResponse<Project>) => {
        setIsLoading(false)
        const project = response.data
        localStorage.setItem('project-id', project.projectId)
        setProject(project)
      })
      .catch((error: any) => {
        setIsLoading(false)
        console.error(error)
      })
  }

  return { project, isLoading }
}